import httpClient from '../../../shared/lib/httpClient';
import { ENDPOINTS } from '../../../shared/services/api/endpoints';

/**
 * Get available SSO providers
 * @returns {Promise<{ success: boolean, data: object|null, message?: string }>}
 */
export async function getSsoProviders() {
  try {
    const response = await httpClient.get(ENDPOINTS.IDENTITY.SSO_PROVIDERS);
    return {
      success: true,
      data: response?.data?.data ?? null,
      message: response?.data?.message
    };
  } catch (error) {
    const message = error.response?.data?.message || 'Failed to fetch SSO providers';
    console.error('Error fetching SSO providers:', error);
    return { success: false, data: null, message };
  }
}

/**
 * Get current SSO configuration for the tenant
 * @returns {Promise<{ success: boolean, data: object|null, message?: string }>}
 */
export async function getSsoConfiguration() {
  try {
    const response = await httpClient.get(ENDPOINTS.IDENTITY.SSO_CONFIGURATION);
    return {
      success: true,
      data: response?.data?.data ?? null,
      message: response?.data?.message
    };
  } catch (error) {
    const message = error.response?.data?.message || 'Failed to fetch SSO configuration';
    console.error('Error fetching SSO configuration:', error);
    return { success: false, data: null, message };
  }
}

/**
 * Update SSO configuration for the tenant
 * @param {Object} config - SSO configuration
 * @param {number} config.externalAuthenticationProviderId - Provider ID
 * @param {string} config.idpAlias - Provider code (GOOGLE, MICROSOFT, etc.)
 * @param {string} config.subdomain - Company domain/subdomain
 * @returns {Promise<{ success: boolean, data?: object, message?: string, status?: number, fieldErrors?: object }>}
 */
export async function updateSsoConfiguration(config) {
  try {
    const response = await httpClient.put(
      ENDPOINTS.IDENTITY.SSO_CONFIGURATION,
      config,
      { timeout: 20000 }
    );
    const message = response?.data?.message || 'SSO configuration updated successfully';
    return {
      success: true,
      data: response?.data?.data ?? null,
      message,
      status: response?.status
    };
  } catch (error) {
    const status = error.response?.status;
    const message = error.response?.data?.message || 'Failed to update SSO configuration';
    const fieldErrors = error.response?.data?.errors || {};
    
    console.error('Error updating SSO configuration:', error);
    
    return {
      success: false,
      message,
      status,
      fieldErrors
    };
  }
}
